import { render } from "./UserCreate.vue?vue&type=template&id=f0c102b4&scoped=true"
import script from "./UserCreate.js?vue&type=script&lang=js&external"
export * from "./UserCreate.js?vue&type=script&lang=js&external"

import "./UserCreate.scss?vue&type=style&index=0&id=f0c102b4&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c102b4"]])

export default __exports__